/**
 * Which sub-views of the AI hub a user may open. Kept out of AIHub.tsx so
 * CRA's jest can test it without resolving react-router-dom.
 *
 * A CUSTOMER sees only Providers: their own keys, which the house mapping
 * then runs on at the own-key rate. Which model runs which stage, and what it
 * cost, is plumbing — admins only.
 */
// 'policy' is the MODEL POLICY: for each job the app hands to an LLM, which
// models are allowed. (It was "pipeline" with "stages" — page building once
// ran as one; nothing does now, and the words only misled.)
export type AISub = 'models' | 'providers' | 'policy' | 'usage';

// Providers first: you register a connection, then the models on it, then
// which jobs each model may do.
const SUB_CONFIG: { key: AISub; label: string; adminOnly?: boolean }[] = [
  { key: 'providers', label: 'Providers' },
  { key: 'models', label: 'Models', adminOnly: true },
  { key: 'policy', label: 'Model policy', adminOnly: true },
  { key: 'usage', label: 'Usage', adminOnly: true },
];

/** The subs this user may open, in display order. */
export function subsFor(isAdmin: boolean): { key: AISub; label: string }[] {
  return SUB_CONFIG.filter((s) => isAdmin || !s.adminOnly).map(({ key, label }) => ({ key, label }));
}
